<template>
    <button v-if="simple" class="layout-config-button config-link" type="button" @click="toggleConfigSidebar">
        <i class="pi pi-cog" />
    </button>
    <Drawer
        v-model:visible="layoutState.configSidebarVisible"
        position="right"
        class="layout-config-sidebar tw:w-full tw:sm:w-72"
        header="Settings"
        :pt="{
            pcCloseButton: { root: 'tw:ml-auto' }
        }"
    >
        <div class="tw:flex tw:flex-col tw:gap-4">
            <PrimaryColorPicker />

            <!--            <template v-if="!simple">-->
            <!--                <div>-->
            <!--                    <div class="tw:flex tw:flex-col tw:gap-2">-->
            <!--                        <span class="tw:text-lg tw:font-semibold">Menu Type</span>-->
            <!--                        <div class="tw:flex tw:flex-wrap tw:flex-col tw:gap-3">-->
            <!--                            <div class="tw:flex">-->
            <!--                                <div class="tw:flex tw:items-center tw:gap-2 tw:w-1/2">-->
            <!--                                    <RadioButton v-model="menuMode" name="menuMode" value="static" input-id="static" @update:modelValue="setMenuMode" />-->
            <!--                                    <label for="static">Static</label>-->
            <!--                                </div>-->

            <!--                                <div class="tw:flex tw:items-center tw:gap-2 tw:w-1/2">-->
            <!--                                    <RadioButton v-model="menuMode" name="menuMode" value="overlay" input-id="overlay" @update:modelValue="setMenuMode" />-->
            <!--                                    <label for="overlay">Overlay</label>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                            <div class="tw:flex">-->
            <!--                                <div class="tw:flex tw:items-center tw:gap-2 tw:w-1/2">-->
            <!--                                    <RadioButton v-model="menuMode" name="menuMode" value="slim" input-id="slim" @update:modelValue="setMenuMode" />-->
            <!--                                    <label for="slim">Slim</label>-->
            <!--                                </div>-->
            <!--                                <div class="tw:flex tw:items-center tw:gap-2 tw:w-1/2">-->
            <!--                                    <RadioButton v-model="menuMode" name="menuMode" value="slim-plus" input-id="slim-plus" @update:modelValue="setMenuMode" />-->
            <!--                                    <label for="slim-plus">Slim+</label>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </template>-->
        </div>
    </Drawer>
</template>

<script setup>
import { computed, ref } from 'vue';
import UserSetting from '@/models/UserSetting.js';
import { useLayout } from './composables/layout.js';
import PrimaryColorPicker from './PrimaryColorPicker.vue';
import { primaryColors } from './theme/ColorThemes.js';

defineProps({
    simple: {
        type: Boolean,
        default: false,
    },
});

const { layoutState, layoutConfig, toggleConfigSidebar } = useLayout();
const menuMode = ref(layoutConfig.menuMode);

function setMenuMode(mode) {
    layoutConfig.menuMode = mode;

    if (mode === 'static') {
        layoutState.staticMenuDesktopInactive = false;
    }
}
</script>
